import React from "react";
import { Container as ChakraContainer } from "@chakra-ui/react";
import { type SectionProps } from "components/section";

const negativePx = `calc(-1 * var(--chakra-space-containerPx-mobile))`;
export const horizontalContainerPadding = { base: "containerPx.mobile", xl: 0 };
export const negativeHorizontalContainerPadding = { base: negativePx, xl: 0 };

export function Container({
  center,
  children,
  fullWidth,
  maxW = "container.section",
  ...props
}: Omit<SectionProps, "theme" | "themeBgColor">) {
  return (
    <ChakraContainer maxW={fullWidth ? "100%" : maxW} centerContent={center} px={horizontalContainerPadding} {...props}>
      {children}
    </ChakraContainer>
  );
}
